import React from 'react';
import styles from "./map-tooltip.module.scss";

const MapToolTip = ({top, left, children, currentMetric = 'totalScore'}) => {
    // Determine border color based on current metric
    const getBorderColor = () => {
        switch (currentMetric) {
            case 'totalScore':
                return '#405363'; // Dark blue for Total R&R
            case 'riskScore':
                return '#920000'; // Red for Risk
            case 'resilienceScore':
                return '#008B25'; // Green for Resilience
            default:
                return '#405363';
        }
    };

    const borderColor = getBorderColor();

    // Smart positioning: if tooltip is in top 20% of viewport, show below; otherwise show above
    const TOOLTIP_THRESHOLD = 0.2; // Top 20% of screen
    const viewportHeight = window.innerHeight;
    const shouldShowBelow = top < (viewportHeight * TOOLTIP_THRESHOLD);

    return (
            <div className = { styles.cityHover} style = {{top: top, left: left}} >
                <div
                    className = {`${styles.cityHoverContainer} ${shouldShowBelow ? styles.showBelow : ''}`}
                    style={{'--tooltip-border-color': borderColor}}
                >
                    <div className = {styles.cityHoverInner} style={{borderColor: borderColor}}>
                        {children}
                    </div>

                </div>
            </div>
        )
}

export default MapToolTip;